import { JWT_VALIDATION_REGEX } from './constants.ts';
import { GlobalErrorPropsType, MasterLayoutProps } from './types.ts';

export const sendGlobalLayoutProps = (newData: MasterLayoutProps) => {
  window.masterLayoutProps = {
    ...(window.masterLayoutProps || {}),
    ...newData,
  };

  const event = new CustomEvent('masterLayoutProps');
  window.dispatchEvent(event);
};

export const sendGlobalErrorProps = (errorProps: GlobalErrorPropsType) => {
  window.masterLayoutProps = {
    ...(window.masterLayoutProps || {}) as MasterLayoutProps,
    ...errorProps,
  };

  const event = new CustomEvent('masterLayoutProps');
  window.dispatchEvent(event);
};

export const parseJwt = (token: string) => {
  const isTokenValid = JWT_VALIDATION_REGEX.test(token);
  if (!isTokenValid) return false;

  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );
  return JSON.parse(jsonPayload);
};

/** waits for the DOM to successfully load the element */
export function waitForElement(selector: string): Promise<Element> {
  return new Promise((resolve): void => {
    if (document.querySelector(selector)) {
      resolve(document.querySelector(selector)!);
      return;
    }

    // if the element was not found, watch for changes to the DOM and resolve when the element is present
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector)!);
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
